import { render, staticRenderFns } from "./SoftwareSerials.vue?vue&type=template&id=65b59f61&scoped=true"
import script from "./SoftwareSerials.vue?vue&type=script&lang=js"
export * from "./SoftwareSerials.vue?vue&type=script&lang=js"
import style0 from "./SoftwareSerials.vue?vue&type=style&index=0&id=65b59f61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b59f61",
  null
  
)

export default component.exports